import { Component } from '@angular/core';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AuthService } from '.././auth.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
    templateUrl: './login.component.html'
})

export class LoginComponent {
    loginForm: UntypedFormGroup;
    isError: boolean = false;
    isBlocked: boolean = false;
    errorMessage: string = '';

    constructor(private fb: FormBuilder, private authService: AuthService, private router: Router) {}

    ngOnInit(): void {
        this.loginForm = this.fb.group({
            userName: [null, [Validators.required, Validators.email]],
            password: [null, [Validators.required]]
        });
    }

    submitForm(): void {
        for (const i in this.loginForm.controls) {
            this.loginForm.controls[i].markAsDirty();
            this.loginForm.controls[i].updateValueAndValidity();
        }

        this.authService.login(this.loginForm.value).subscribe(
            (res: any) => {
                if (res.blocked) {
                    this.isBlocked = true;
                } else {
                    this.isBlocked = false;
                    localStorage.setItem('authorization', JSON.stringify(res.authorization));
                    localStorage.setItem('name', JSON.stringify(res.name));
                    localStorage.setItem('lastName', JSON.stringify(res.lastName));
                    localStorage.setItem('email', this.loginForm.value.userName);
                    localStorage.setItem('permissions', JSON.stringify(res.permissions));

                    if (res.permissions.length === 1 && res.permissions.includes('external_reporting')) {
                        this.router.navigate(['/apps/externalreports']);
                    } else {
                        this.router.navigate(['/']);
                    }
                }
                this.isError = false;
                this.errorMessage = ''; // Reset error message on success
            },
            (err: HttpErrorResponse) => {
                this.isError = true;
                this.isBlocked = false;

                if (err.status === 403) {
                    this.errorMessage = 'Access Denied: You do not have the necessary permissions.';
                } else {
                    this.errorMessage = 'Login failed. Please check your credentials and try again.';
                }
            }
        );
    }
}
